import React from "react";
import Layout from "../../components/Layout";
import PropertyManager from "./PropertyManager";
import Tenant from "./Tenant";
import "./styles.css";

function AppHome() {
  const isPropertyManager =
    localStorage.getItem("userType") === "propertymanager" || false;

  return (
    <Layout>{isPropertyManager ? <PropertyManager /> : <Tenant />}</Layout>
  );
}

export default AppHome;
